export enum PoiNavigationSource {
    PointerSelection = 'PointerSelection',
    PoiStepper = 'PoiStepper'
}
